import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import {Label} from 'lib/ui/typography'
import styled from 'styled-components'
import TextField from 'lib/ui/TextField'
import {Snackbar} from 'lib/ui/Snackbar'
import TextArea from 'lib/ui/TextField/TextArea'
import ColorPicker from 'lib/ui/ColorPicker'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {usePanelsTemplate} from 'Event/template/Panels'
import {useAttendeeVariables} from 'Event'
import {useUserTranslations} from 'Event/LanguageProvider/translations'

export default function Settings(props: {
  control: UseFormMethods['control']
  register: UseFormMethods['register']
  watch: UseFormMethods['watch']
}) {
  const template = usePanelsTemplate()
  const {leaderboard, rewardAlert} = template
  const {control, register, watch} = props
  const v = useAttendeeVariables()
  const translate = useUserTranslations()

  const rewardText: string =
    watch('rewardAlert.text') ?? translate(rewardAlert.text)
  const rewardTextColor: string =
    watch('rewardAlert.textColor') ?? rewardAlert.textColor
  const rewardBackgroundColor: string =
    watch('rewardAlert.backgroundColor') ?? rewardAlert.backgroundColor

  return (
    <>
      <Label>Title</Label>
      <TextField
        name="title"
        aria-label="set leaderboard page title"
        defaultValue={v(leaderboard.title)}
        fullWidth
        inputProps={{
          ref: register({
            required: 'Title is required',
          }),
        }}
      />
      <Controller
        name="description"
        control={control}
        defaultValue={v(leaderboard.description)}
        rules={{
          required: 'Description is required',
        }}
        render={({value, onChange}) => (
          <HTMLEditorContainer>
            <HTMLEditor
              data={value}
              onChange={onChange}
              customLinks={['Leaderboard']}
            />
          </HTMLEditorContainer>
        )}
      />
      <Label>Menu Title</Label>
      <TextField
        name="menuTitle"
        aria-label="set leaderboard page menu title"
        fullWidth
        defaultValue={v(leaderboard.menuTitle)}
        inputProps={{
          ref: register({
            required: 'Menu title is required',
          }),
        }}
      />
      <Label>Points Unit</Label>
      <TextField
        name="points_unit"
        aria-label="points unit"
        fullWidth
        defaultValue={v(template.points_unit)}
        inputProps={{
          ref: register({
            required: 'Points unit is required',
          }),
        }}
      />
      <Snackbar
        style={{marginBottom: '24px'}}
        message={
          <Container>
            <CheckCircleIcon />
            <StyledDiv>{rewardText}</StyledDiv>
          </Container>
        }
        color={rewardTextColor}
        backgroundColor={rewardBackgroundColor}
      />
      <ColorPickerContainer>
        <Controller
          name="rewardAlert.backgroundColor"
          control={control}
          defaultValue={rewardAlert.backgroundColor}
          render={({value, onChange}) => (
            <ColorPicker
              label="Popup Background Color"
              color={value}
              onPick={onChange}
            />
          )}
        />
        <Controller
          name="rewardAlert.textColor"
          control={control}
          defaultValue={rewardAlert.textColor}
          render={({value, onChange}) => (
            <ColorPicker label="Popup Color" color={value} onPick={onChange} />
          )}
        />
      </ColorPickerContainer>
      <Label>Popup Text</Label>
      <TextArea
        name="rewardAlert.text"
        label="Popup Text"
        aria-label="set leaderboard popup text"
        fullWidth
        defaultValue={translate(rewardAlert.text)}
        rows={3}
        variant="outlined"
        inputProps={{
          ref: register({required: 'Title is required'}),
          onKeyDown: (e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
            }
          },
        }}
      />
    </>
  )
}

const Container = styled.div`
  display: flex;
`
const StyledDiv = styled.div`
  font-size: 19px;
`
const ColorPickerContainer = styled.div`
  display: flex;
`
